import axiosActionsFactory from '../../axiosHelpers';
import { UrlService } from '../../../../services';
import { getSelectedCompany } from '../../../selectors';

export const GET_PROVIDER_ACCOUNT_AUTH_TOKEN = axiosActionsFactory('GET_PROVIDER_ACCOUNT_AUTH_TOKEN');

const getProviderAccountAuthToken = (accountId, contextCompanyId, requestBody) => (dispatch) => dispatch({
  type: GET_PROVIDER_ACCOUNT_AUTH_TOKEN.START,
  payload: {
    request: {
      url: UrlService.providerAccountAuthToken(accountId),
      method: 'post',
      data: requestBody,
      params: { contextCompanyId },
    },
  },
});

export const getAccountAuthToken = (accountId, stateId, authCode) => (dispatch, getState) => {
  const state = getState();
  const contextCompanyId = getSelectedCompany(state);

  return dispatch(getProviderAccountAuthToken(accountId, contextCompanyId, { stateId, authCode }));
};
